import { render, staticRenderFns } from "./groupChatView.vue?vue&type=template&id=dd9d39a6&scoped=true&"
import script from "./groupChatView.vue?vue&type=script&lang=js&"
export * from "./groupChatView.vue?vue&type=script&lang=js&"
import style0 from "./groupChatView.vue?vue&type=style&index=0&id=dd9d39a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9d39a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd9d39a6')) {
      api.createRecord('dd9d39a6', component.options)
    } else {
      api.reload('dd9d39a6', component.options)
    }
    module.hot.accept("./groupChatView.vue?vue&type=template&id=dd9d39a6&scoped=true&", function () {
      api.rerender('dd9d39a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/groupChatView.vue"
export default component.exports